import { FilterForm } from '@/components/common/Filter'
import {
  type FilterAdvancedPartialType,
  type FilterAdvancedSlugType,
  type FilterAdvancedType,
  isFilterAdvancedCardPartialType,
  isFilterAdvancedCountPartialType,
  isFilterAdvancedPricePartialType,
  isFilterAdvancedType,
  withFilterAdvancedDefaults,
} from '@/defs/filters'
import { type DropdownOptionGroupType } from '@/defs/input'

import { FiltersPanelAdvancedFormCard } from './FiltersPanelAdvancedFormCard/FiltersPanelAdvancedFormCard'
import { FiltersPanelAdvancedFormCount } from './FiltersPanelAdvancedFormCount/FiltersPanelAdvancedFormCount'
import { FiltersPanelAdvancedFormPrice } from './FiltersPanelAdvancedFormPrice/FiltersPanelAdvancedFormPrice'

type Props = {
  filter: FilterAdvancedPartialType
  onDelete: () => void
  onSubmit: (f: FilterAdvancedType) => void
  onUpdate: (f: FilterAdvancedPartialType) => void
  optionGroups: DropdownOptionGroupType<FilterAdvancedSlugType>[]
}

export const FiltersPanelAdvancedForm = ({
  filter,
  onDelete,
  onSubmit: onSubmitProp,
  onUpdate,
  optionGroups,
}: Props) => {
  const invalid = !isFilterAdvancedType(filter)

  const onSubmit = () => {
    if (isFilterAdvancedType(filter)) onSubmitProp(filter)
  }

  const onSelectOption = (slug: FilterAdvancedSlugType) => {
    onUpdate(withFilterAdvancedDefaults(slug, filter))
  }

  const formElement = isFilterAdvancedCountPartialType(filter) ? (
    <FiltersPanelAdvancedFormCount filter={filter} onUpdate={onUpdate} />
  ) : isFilterAdvancedCardPartialType(filter) ? (
    <FiltersPanelAdvancedFormCard filter={filter} onSubmit={onSubmitProp} onUpdate={onUpdate} />
  ) : isFilterAdvancedPricePartialType(filter) ? (
    <FiltersPanelAdvancedFormPrice filter={filter} onUpdate={onUpdate} />
  ) : null

  return (
    <FilterForm
      invalid={invalid}
      onDelete={onDelete}
      onSelectOption={onSelectOption}
      onSubmit={onSubmit}
      optionGroups={optionGroups}
      value={filter.slug}
    >
      {formElement}
    </FilterForm>
  )
}
